document.addEventListener('DOMContentLoaded', function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var variant = event && event.data && event.data.variant;
    var sectionId = event && event.data && event.data.sectionId;
    if (!variant || !sectionId) return;

    var priceEl = document.querySelector(
      '#ProductSubmitButton-' + sectionId + ' .ozea-atc-button__price'
    );
    if (priceEl && typeof variant.price === 'number') {
      priceEl.textContent = '$' + (variant.price / 100).toFixed(2);
    }
  });
});
